module.exports = __webpack_public_path__ + "static/media/tapped.fc2ec196.svg";